import React, { useRef, useState, useCallback } from 'react';
import { Button, Image, Overlay, Popover } from 'react-bootstrap';
import { SortOption } from '../types';
import Sort from '../../../assets/images/sort.png';

interface SortComponentProps {
  sortData: SortOption[];
  onSort: (sortOption: SortOption) => void;
  styles: any;
}

const SortComponent: React.FC<SortComponentProps> = React.memo(({
  sortData,
  onSort,
  styles
}) => {
  const [showSortPopover, setShowSortPopover] = useState(false);
  const target = useRef(null);

  const handleSortClick = useCallback((sortOption: SortOption) => {
    onSort(sortOption);
    setShowSortPopover(false);
  }, [onSort]);

  const handleOverlayClose = useCallback(() => {
    setShowSortPopover(false);
  }, []);

  const togglePopover = useCallback(() => {
    setShowSortPopover(prev => !prev);
  }, []);

  return (
    <div ref={target}>
      <Button
        style={styles.btnSort}
        variant="outline-primary"
        onClick={togglePopover}
        aria-label="Sort options"
      >
        <Image src={Sort} className="sortImage" alt="Sort" />
      </Button>
      
      <Overlay
        show={showSortPopover}
        target={target.current}
        placement="bottom"
        containerPadding={20}
        container={document.body}
        onHide={handleOverlayClose}
        rootClose
      >
        <Popover id="sort-popover">
          <Popover.Body>
            <ul
              className="sortPopover"
              style={{ listStyleType: "none", padding: 0, margin: 0 }}
            >
              {sortData.map((sortOption) => (
                <li key={sortOption.id}>
                  <Button
                    variant="link"
                    onClick={() => handleSortClick(sortOption)}
                    className="text-start w-100 p-2"
                    style={{ textDecoration: 'none' }}
                  >
                    {sortOption.name}
                  </Button>
                </li>
              ))}
            </ul>
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
});

SortComponent.displayName = 'SortComponent';

export default SortComponent;